import { Region } from './countriesConfig';

//Note: if for any reason there is necessity of modifying the names, please remember to check the production database to ensure everything is up to date
export const SPAIN_REGIONS = [
    {
        name: 'Andalucía',
        code: 'ES-AN',
        provinces: [
            { name: 'Almería', code: 'AL' },
            { name: 'Cádiz', code: 'CA' },
            { name: 'Córdoba', code: 'CO' },
            { name: 'Granada', code: 'GR' },
            { name: 'Huelva', code: 'H' },
            { name: 'Jaén', code: 'J' },
            { name: 'Málaga', code: 'MA' },
            { name: 'Sevilla', code: 'SE' },
        ],
    },
    {
        name: 'Aragón',
        code: 'ES-AR',
        provinces: [
            { name: 'Huesca', code: 'HU' },
            { name: 'Teruel', code: 'TE' },
            { name: 'Zaragoza', code: 'Z' },
        ],
    },
    {
        name: 'Asturias',
        code: 'ES-AS',
        provinces: [{ name: 'Asturias', code: 'AS' }],
    },
    {
        name: 'Islas Baleares',
        code: 'ES-IB',
        provinces: [{ name: 'Islas Baleares', code: 'IB' }],
    },
    {
        name: 'País Vasco',
        code: 'ES-PV',
        provinces: [
            { name: 'Álava', code: 'VI' },
            { name: 'Bizkaia', code: 'BI' },
            { name: 'Gipuzkoa', code: 'SS' },
        ],
    },
    {
        name: 'Canarias',
        code: 'ES-CN',
        provinces: [
            { name: 'Las Palmas', code: 'GC' },
            { name: 'Santa Cruz de Tenerife', code: 'TF' },
        ],
    },
    {
        name: 'Cantabria',
        code: 'ES-CB',
        provinces: [{ name: 'Cantabria', code: 'CB' }],
    },
    {
        name: 'Castilla y León',
        code: 'ES-CL',
        provinces: [
            { name: 'Ávila', code: 'AV' },
            { name: 'Burgos', code: 'BU' },
            { name: 'León', code: 'LE' },
            { name: 'Palencia', code: 'P' },
            { name: 'Salamanca', code: 'SA' },
            { name: 'Segovia', code: 'SG' },
            { name: 'Soria', code: 'SO' },
            { name: 'Valladolid', code: 'VA' },
            { name: 'Zamora', code: 'ZA' },
        ],
    },
    {
        name: 'Castilla-La Mancha',
        code: 'ES-CM',
        provinces: [
            { name: 'Albacete', code: 'AB' },
            { name: 'Ciudad Real', code: 'CR' },
            { name: 'Cuenca', code: 'CU' },
            { name: 'Guadalajara', code: 'GU' },
            { name: 'Toledo', code: 'TO' },
        ],
    },
    {
        name: 'Cataluña',
        code: 'ES-CT',
        provinces: [
            { name: 'Barcelona', code: 'B' },
            { name: 'Girona', code: 'GI' },
            { name: 'Lleida', code: 'L' },
            { name: 'Tarragona', code: 'T' },
        ],
    },
    {
        name: 'Extremadura',
        code: 'ES-EX',
        provinces: [
            { name: 'Badajoz', code: 'BA' },
            { name: 'Cáceres', code: 'CC' },
        ],
    },
    {
        name: 'Galicia',
        code: 'ES-GA',
        provinces: [
            { name: 'A Coruña', code: 'C' },
            { name: 'Lugo', code: 'LU' },
            { name: 'Ourense', code: 'OR' },
            { name: 'Pontevedra', code: 'PO' },
        ],
    },
    {
        name: 'La Rioja',
        code: 'ES-RI',
        provinces: [{ name: 'La Rioja', code: 'RI' }],
    },
    {
        name: 'Comunidad de Madrid',
        code: 'ES-MD',
        provinces: [{ name: 'Madrid', code: 'MD' }],
    },
    {
        name: 'Región de Murcia',
        code: 'ES-MC',
        provinces: [{ name: 'Murcia', code: 'MC' }],
    },
    {
        name: 'Navarra',
        code: 'ES-NC',
        provinces: [{ name: 'Navarra', code: 'NC' }],
    },
    {
        name: 'Comunidad Valenciana',
        code: 'ES-VC',
        provinces: [
            { name: 'Alicante', code: 'A' },
            { name: 'Castellón', code: 'CS' },
            { name: 'Valencia', code: 'V' },
        ],
    },
    {
        name: 'Ceuta',
        code: 'ES-CE',
        provinces: [{ name: 'Ceuta', code: 'CE' }],
    },
    {
        name: 'Melilla',
        code: 'ES-ML',
        provinces: [{ name: 'Melilla', code: 'ML' }],
    },
] as const satisfies [Region, ...Region[]];
